import * as React from "react";
import hash from "../../assets/hash.png";
import * as Modal from "react-modal";
import { toast } from "react-toastify";

export default class Header extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
    this.state = {
        modalOn: false
    };
  }


  componentDidMount() {

  }

  getCSV = async () => {
    try {
      const response = await fetch("users/export", {
        method: "post",
        body: JSON.stringify({
          international: false,
          columns: ["name", "followers"],
        }),
      });
      if (response) {
        this.setState({ exportModal: false });
        const data = await response.text();
        this.loadCSV(data);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  loadCSV = (data: any) => {
    const loadCSVButton = document.createElement("a");
    loadCSVButton.setAttribute("download", this.props.campaign.title+".csv");
    loadCSVButton.setAttribute("href", `data:text/csv;,${data}`);
    loadCSVButton.style.display = "none";
    document.body.appendChild(loadCSVButton);
    loadCSVButton.click();
    document.body.removeChild(loadCSVButton);
  };




  public render() {
    const {campaign,user} = this.props
    return (
        <div className="buttonsHeader single">
          <i className="fa fa-bars" onClick={() => {this.props.openMenu()}}></i>
          <h1><img src={hash}/>קמפיין {campaign?.title}{user? ": "+user.name : ""}</h1>
          <div className="buttonsDiv">
          <button
            onClick={() => {
                this.getCSV()
            }}
          >
           ייצא לאקסל
          </button>
          <button
            onClick={() => {
                this.setState({
                    modalOn: true,
                  });
            }}
          >
            פיקסל מעקב
          </button>
          <button
            className={this.props.activeTab === "users"? "active" : ""}
            onClick={() => {
              window.location.href = `/campaigns/${campaign?.id}/users`
            }}
          >
            משפיענים
          </button>
          <button
            className={this.props.activeTab === "sales"? "active" : ""}
            onClick={() => {
              window.location.href = `/campaigns/${campaign?.id}/`
            }}
          >
            מכירות
          </button>
          <div className="clearfix"></div>
          </div>
          <Modal isOpen={this.state.modalOn} className="code-modal">
          <a
            className="fa fa-times"
            onClick={() => {
              this.setState({
                modalOn: false,
              });
            }}
          ></a>

          <p>אנא העתק/י את הקוד המופיע אל אתר האינטרנט הרלוונטי. על הקוד להיות תחת תגית ה head של האתר. לצפייה בסרטון הדכה לחצ/י כאן.</p>
          <code>
            {campaign?.code || `	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('js', new Date());

	gtag('config', 'G-XL3TZG4WWB');`}
          </code>
        </Modal>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/campaign/Header.tsx